import { render } from "./fpupdate.vue?vue&type=template&id=77f7b9d8"
import script from "./fpupdate.vue?vue&type=script&lang=js"
export * from "./fpupdate.vue?vue&type=script&lang=js"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__